export const linkBrokenIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10.283 2.645l-2.318 2.32 1.414 1.414 2.318-2.32c2.653-2.7 6.968 1.052 4.426 4.045l-2.504 2.516 1.416 1.416 2.502-2.504c4.67-4.917-2.748-11.631-7.254-6.887zM4.961 7.961l-2.496 2.496c-4.672 4.918 2.75 11.628 7.254 6.887l2.313-2.312-1.414-1.414-2.313 2.313c-2.653 2.7-6.968-1.052-4.426-4.045l2.498-2.508z"/></svg>`,
  name: 'link-broken',
};
